<template>
  <v-card flat>
    <v-card-text>
      <v-row v-if="hasErrors">
        <v-col cols="12">
          <v-alert
            v-for="(error, index) in errors"
            :key="index"
            border="right"
            colored-border
            type="error"
            elevation="2"
          >
            {{ error.message }}
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="hasDocument">
        <v-col cols="10">
          <ace-editor :content="content" />
        </v-col>
        <v-col cols="2">
          <p>
            {{ collection.cosmos }}
          </p>
          <p>{{ selector }}</p>
          <p>{{ params }}</p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('home/cosmos')
import AceEditor from '@/components/AceEditor'

export default {
  props: {
    collection: {
      type: Object
    },
    selector: {
      type: String
    },
    params: {
      type: Object
    }
  },
  components: { AceEditor },
  computed: {
    ...mapGetters(['errors', 'hasErrors', 'hasDocument', 'content'])
  },
  data() {
    return {}
  }
}
</script>
